export const REVIEW_COUNT_PER_PAGE = 10;
